 /* eslint-disable */
 export default class ResultadoConsulta{

    constructor(){
        this.ReporteHtml = "";
        this.Errores = [],
        this.EsValido = false;
    }

    ReporteHtml : string;
    Errores : any[];
    EsValido : boolean;
    
}